import React, { Component, Suspense, Dispatch } from 'react';
import { Common } from '../../core/common';
import { LoginService } from '../../api/login-service';
import Auth from '../_shared/Auth';
import CMainMenu from '../main-navigation/main-menu';
import { BrowserRouter as Router, Link, Route, withRouter } from 'react-router-dom';
import Routes from '../../core/routes';
import { IAppState, IAction } from '../../models/action/core';
import { connect } from 'react-redux';
import { IMainPageProps } from '../../models/pages/main';
import * as Actions from '../../store/actions/login';
import * as ProfilePageAction from '../../store/actions/profile';
import { ActivityTypeEnums } from '../../models/enums/ActivityType';
import PermissionGenerator, { SecurityContextType, SecurityPermissionType } from '../../core/SecurityContext';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';

const _logger = Log.create('main.txs');
const T = Translator.create();
let _common: Common;
let _loginService: LoginService;

export class Main extends React.Component<any, any> {
  public inputum: HTMLInputElement | null = null;
  public state = { isAuth: 1, isTimezoneCheck: false, isTimezoneShow: false };
  constructor(props: any) {
    super(props);
    _loginService = new LoginService();
    _common = new Common();
  }

  public refInput = (event: any) => {
    if (event) {
      this.inputum = event;
    }
  }
  public componentDidMount() {
    this.getDiffrentTimeZoneCheck()
    if (_common.GetAuthLocalStorage().access_token === '') {
      this.setState({ isAuth: 0 });
    }
  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any): void {
    if (prevProps !== this.props) {
      this.getDiffrentTimeZoneCheck()
    }
  }

  public LogOff = () => {
    this.props.dispatch(ProfilePageAction.setProfileAction(null, "setProfileAction", "set"))
    _common.ClearAuthLocalStorage();
    this.props.dispatch(Actions.logOff());
    this.setState({ isAuth: 0 });
  }

  public displayAll = () => {
    this.props.history.push(window.appSettings.DEFAULT_URL + '/u/activities-dashboard?activityType=Assignment');
  }

  getCurrentTimeZone = () => {
    return new Date().getTimezoneOffset();
  };

  getDiffrentTimeZoneCheck = () => {
    if (this.props.timeZone) {
      const getUTCOffsetFromTimeZone = (timeZone: any) => {
        const now = new Date();
        const formatter = new Intl.DateTimeFormat('en-US', {
          timeZone,
          timeZoneName: 'short',
        });
        const parts = formatter.formatToParts(now);
        const utcOffsetPart = parts.find((part) => part.type === 'timeZoneName');
        return utcOffsetPart ? utcOffsetPart.value : null;
      };

      const parseUTCOffset = (utcOffsetString: any) => {
        const match = utcOffsetString.match(/GMT([+-]\d+)/);
        return match ? parseInt(match[1], 10) : null;
      };

      const userUTCOffset = -(this.getCurrentTimeZone() / 60);
      const apiTimeZone = this.props.timeZone;
      const apiUTCOffsetString = getUTCOffsetFromTimeZone(apiTimeZone);

      if (apiUTCOffsetString !== null) {
        const apiUTCOffset = parseUTCOffset(apiUTCOffsetString);
        if (userUTCOffset === apiUTCOffset) {
          this.setState({ isTimezoneCheck: false });
        } else {
          this.setState({ isTimezoneCheck: true });
        }
      } else {
        this.setState({ isTimezoneCheck: false });
      }
    }
  };

  public render() {
    return (
      <div>
        {this.state.isTimezoneCheck &&
          <div className={`timezone-warning-message ${this.state.isTimezoneShow && "d-none"}`} style={{ position: "fixed", bottom: 0, width: "100%" }}>
            <div className="message-content">
              <i className="material-icons mr-2">schedule</i>
              <span>
                {T.t('timezoneWarning')}{' '}
                <Link style={{ color: 'black' }} to={`${window.appSettings.DEFAULT_URL}/u/profile`}>
                  <span style={{ fontWeight: 'bold' }}>{T.t('personalInfo')}</span>
                </Link>{' '}
                {T.t('adjustTimezone')}
              </span>
            </div>
            <i onClick={() => this.setState({ isTimezoneShow: true })} className="material-icons mr-2 cursor-pointer">close</i>
          </div>
        }
        <CMainMenu isMessageModelOpen={this.props.isMessageModelOpen} triggerMessageModal={this.props.triggerMessageModal} />
        {/* <div>
          <Suspense fallback={(<h1>YÜKLENİYOR...</h1>)}>
            {
              Routes.map(r => {
                return (<Route key={r.path} path={r.path} component={r.component} />);
              })
            }
          </Suspense>
        </div> */}
        {/*  <div style={{ marginTop: '70px' }}>
          <Auth />
          <button onClick={this.LogOff} className="btn btn-danger" >Çıkış</button>
          <button className="btn btn-warning" onClick={this.toAlms}>Alms Geçiş</button>
          <button onClick={this.displayAll} className="btn btn-info">Tümünü Göster</button>
        </div> */}
      </div>
    );
  }
}


const mapStateToProps = (state: IAppState, ownProps: IMainPageProps): IMainPageProps => {

  if (!state) {
    return ownProps;
  }
  const newProps: IMainPageProps = Object.assign({}, ownProps, {
    timeZone: state.login.identitiy.timeZone,
  });
  return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => ({
  dispatch
});

const CMain = connect(
  mapStateToProps,
  dispatchProps
)(Main);


export default withRouter(CMain);
